import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FusionviewManagerService {
  constructor() {
    console.log('FusionviewManagerService initialized');
  }

  public goToFusionView(fusionViewId: string) {
    if (window.parent.openFusionView) {
      const url = new URL(window.parent.location.href);

      window.parent.openFusionView(window.parent.location.origin + window.parent.location.pathname.replace(/\/[^/]+\/?$/, '/' + fusionViewId + '/') + url.search);
    } else {
      console.error('"goToFusionView" can only be used in fusion-view context');
    }
  }
}